<template>
	<Row>
		<Container>
			<div class="traders-container">
				<img
					:src="imageSrc"
					:alt="altText"
					class="trader-image"
				/>
				<div class="traders-content">
					<div class="traders-content-header">
						<NuxtLink
							:href="profileLink"
							class="author-name"
						>
							{{ name }}
						</NuxtLink>
						<div class="social-media-links">
							<NuxtLink
								:href="twitterLink"
								target="_blank"
							>
								<img
									src="/images/TwitterLogoBird.svg"
									alt="Twitter Logo Bird"
									class="social-media-image"
								/>
							</NuxtLink>
							<NuxtLink
								:href="youtubeLink"
								target="_blank"
							>
								<img
									src="/images/youtube-white-icon.svg"
									alt="Youtube Logo Branco"
									class="social-media-image"
								/>
							</NuxtLink>
						</div>
					</div>
					<div class="trader-content-wrapper">
						<p
							v-for="(paragraph, pIndex) in paragraphs"
							:key="pIndex"
							class="trader-content-paragraph"
						>
							{{ paragraph }}
						</p>
						<div
							v-if="showMore"
							class="additional-content"
						>
							<p
								v-for="(paragraph, pIndex) in additionalContent"
								:key="pIndex"
								class="trader-content-paragraph"
							>
								{{ paragraph }}
							</p>
						</div>
						<button
							class="show-more-button"
							@click="toggleShowMore(index)"
						>
							{{ showMore ? "Hide More" : "Show More" }}
						</button>
					</div>
				</div>
			</div>
		</Container>
	</Row>
</template>

<script>
export default {
	props: {
		name: String,
		imageSrc: String,
		altText: String,
		profileLink: String,
		twitterLink: String,
		youtubeLink: String,
		paragraphs: Array,
		additionalContent: Array
	},
	data() {
		return {
			showMore: false
		};
	},
	mounted() {},
	methods: {
		toggleShowMore() {
			this.showMore = !this.showMore;
		}
	}
};
</script>
<style scoped lang="scss">
@use "~/assets/utils.scss" as *;

.traders-container {
	display: block;
	gap: 64px;

	.trader-image {
		border-radius: 16px;
		object-fit: cover;
	}

	.traders-content {
		.traders-content-header {
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-top: 24px;
			.author-name {
				font-family: Open Sauce Sans;
				font-size: 28px;
				font-weight: 700;
				line-height: 28px;
				letter-spacing: 0px;
				text-align: left;
				color: white;

				&:hover {
					color: #4383ff;
				}

				&::after {
					content: "";
					margin: 0 24px;
					border-left: 1px solid rgba(255, 255, 255, 0.2);
					height: 1em;
				}
			}

			.social-media-links {
				display: flex;
				flex-direction: row;
				gap: 16px;
			}
		}

		.trader-content-wrapper {
			.trader-content-paragraph {
				padding-top: 32px;
				font-family: DM Sans;
				font-size: 18px;
				font-weight: 400;
				line-height: 27px;
				letter-spacing: 0px;
				text-align: left;
				color: $slate-100;
			}

			.show-more-button {
				padding-top: 24px;
				font-family: DM Sans;
				font-size: 18px;
				font-weight: 700;
				line-height: 26px;
				letter-spacing: 0px;
				text-align: left;
				color: #4383ff;

				&:hover {
					text-decoration: underline;
				}
			}
		}
	}

	@include breakpoint(md) {
		display: flex;

		.trader-image {
			max-width: 400px;
			max-height: 426px;
		}

		.traders-content-header {
			margin-top: 0px;
		}
	}
}
</style>
